import { API_ENDPOINT } from "src/constants/endpoints";

export interface FinancePaymentAccount {
  provider: string;
  status: string;
  merchantName?: string | null;
  merchantId?: string | null;
  onboardingStatus?: string | null;
  processingEnabled: boolean;
  settlementEnabled: boolean;
  approvedAt?: string | null;
  action?: "START" | "REFRESH" | "NONE";
  message?: string | null;
}

export interface FinanceTransaction {
  id: string;
  orderCorrelationId?: string | null;
  orderNumber?: string | null;
  customer?: string | null;
  date?: string | null;
  amountCents?: number | null;
  status?: string | null;
  paymentMethod?: string | null;
  transferId?: string | null;
  provider?: string | null;
  refundEligible: boolean;
}

export interface FinancePayout {
  settlementId?: string | null;
  depositDate?: string | null;
  grossAmountCents?: number | null;
  feeAmountCents?: number | null;
  netAmountCents?: number | null;
  status?: string | null;
}

export interface FinanceDisputeEvidence {
  correlationId?: string | null;
  finixEvidenceId?: string | null;
  evidenceType?: string | null;
  fileName?: string | null;
  contentType?: string | null;
  fileSizeBytes?: number | null;
  notes?: string | null;
  submittedToFinix?: boolean | null;
  submittedAt?: string | number | null;
  createdAt?: string | number | null;
}

export interface FinanceDispute {
  correlationId?: string | null;
  disputeId?: string | null;
  transferId?: string | null;
  paymentCorrelationId?: string | null;
  customerOrderCorrelationId?: string | null;
  storeCorrelationId?: string | null;
  status?: string | null;
  reason?: string | null;
  amountCents?: number | null;
  currency?: string | null;
  respondBy?: string | number | null;
  submittedAt?: string | number | null;
  createdAt?: string | number | null;
  evidence?: FinanceDisputeEvidence[] | null;
}

export interface FinanceOverview {
  paymentAccount: FinancePaymentAccount;
  todaysSalesCents: number;
  pendingPayoutAmountCents: number;
  lastPayout?: FinancePayout | null;
  recentTransactions: FinanceTransaction[];
}

export interface FinixComplianceForm {
  id: string;
  type?: string | null;
  version?: string | null;
  state?: string | null;
  displayState: string;
  createdAt?: string | null;
  updatedAt?: string | null;
  dueAt?: string | null;
  validFrom?: string | null;
  validUntil?: string | null;
  unsignedDocumentAvailable: boolean;
  signedDocumentAvailable: boolean;
  canAttest: boolean;
  signerName?: string | null;
  signerTitle?: string | null;
  signedAt?: string | null;
}

export interface FinixComplianceFormsResponse {
  storeCorrelationId: string;
  paymentAccountConnected: boolean;
  forms: FinixComplianceForm[];
}

export const pciComplianceUrl = (storeCorrelationId: string, suffix = "") =>
  `${API_ENDPOINT}finix/pci-compliance/${encodeURIComponent(storeCorrelationId)}${suffix}`;

export const financeUrl = (path: string, storeCorrelationId?: string, params?: Record<string, string | number>) => {
  const search = new URLSearchParams();
  if (storeCorrelationId) search.set("storeCorrelationId", storeCorrelationId);
  Object.entries(params ?? {}).forEach(([key, value]) => search.set(key, String(value)));
  const query = search.toString();
  return `${API_ENDPOINT}finance/${path}${query ? `?${query}` : ""}`;
};
